module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel04_1280_1280_ko-ce054c6ff6c6c45115aa15accc688e79.jpg";